export class StorageUtil {
    /**
     * Set item in localStorage
     */
    static setLocal(key: string, value: any): void {
      try {
        const serialized = JSON.stringify(value);
        localStorage.setItem(key, serialized);
      } catch (error) {
        console.error('Error saving to localStorage:', error);
      }
    }
  
    /**
     * Get item from localStorage
     */
    static getLocal<T>(key: string): T | null {
      try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
      } catch (error) {
        console.error('Error reading from localStorage:', error);
        return null;
      }
    }
  
    /**
     * Remove item from localStorage
     */
    static removeLocal(key: string): void {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error('Error removing from localStorage:', error);
      }
    }
  
    /**
     * Clear all items from localStorage
     */
    static clearLocal(): void {
      try {
        localStorage.clear();
      } catch (error) {
        console.error('Error clearing localStorage:', error);
      }
    }
  
    /**
     * Set item in sessionStorage
     */
    static setSession(key: string, value: any): void {
      try {
        const serialized = JSON.stringify(value);
        sessionStorage.setItem(key, serialized);
      } catch (error) {
        console.error('Error saving to sessionStorage:', error);
      }
    }
  
    /**
     * Get item from sessionStorage
     */
    static getSession<T>(key: string): T | null {
      try {
        const item = sessionStorage.getItem(key);
        return item ? JSON.parse(item) : null;
      } catch (error) {
        console.error('Error reading from sessionStorage:', error);
        return null;
      }
    }
  
    /**
     * Remove item from sessionStorage
     */
    static removeSession(key: string): void {
      try {
        sessionStorage.removeItem(key);
      } catch (error) {
        console.error('Error removing from sessionStorage:', error);
      }
    }
  
    /**
     * Clear all items from sessionStorage
     */
    static clearSession(): void {
      try {
        sessionStorage.clear();
      } catch (error) {
        console.error('Error clearing sessionStorage:', error);
      }
    }
  
    /**
     * Check if localStorage is available
     */
    static isLocalStorageAvailable(): boolean {
      try {
        const test = '__localStorage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch {
        return false;
      }
    }
  
    /**
     * Check if sessionStorage is available
     */
    static isSessionStorageAvailable(): boolean {
      try {
        const test = '__sessionStorage_test__';
        sessionStorage.setItem(test, test);
        sessionStorage.removeItem(test);
        return true;
      } catch {
        return false;
      }
    }
  }
  
  